module.exports = __webpack_public_path__ + "static/img/基础档案.9a95c37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/基础档案.png
// module id = a3tX
// module chunks = 2